import { AbstractControl, ValidationErrors } from "@angular/forms";

export class MiProValidators {
    static requiredField(field: string) {
        return (control: AbstractControl): ValidationErrors => {
            if (!field) {
                return null;
            }

            const fieldValue = (control?.value ?? {})[field];
            const isEmpty =
                fieldValue == null || ((typeof fieldValue === "string" || Array.isArray(fieldValue)) && fieldValue.length === 0);

            return isEmpty ? { required: true } : null;
        };
    }
}
